<template>
  <nav>
    <ul class="nav-list">
      <li class="logo">
        <a href="index.html"
          ><img
            src="@/images/logo.png"
            alt="Reeracoen Freelance Recruiting Business"
        /></a>
      </li>
      <li class="btn-group">
        <ul class="list">
          <li class="login-button">
            <a class="btn btn-outline" href="#">Login</a>
          </li>
          <li class="register-button">
            <a class="btn btn-blue" href="#">Register</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "Nav",
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
nav {
  .nav-list {
    align-items: center;
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem 2rem;

    .logo {
      img {
        width: 200px;
      }
    }

    .btn-group {
      .list {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        line-height: 0;
        padding: 0;

        & > * {
          padding: 0 1rem;

          .btn {
            width: 120px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  nav {
    .nav-list {
      padding: 1.5rem 1rem;

      .logo {
        img {
          width: 120px;
        }
      }

      .btn {
        font-size: 12px;
        padding: 10px 10px;
      }

      .btn-group {
        .list {
          line-height: 0;
          padding-left: 0;

          & > * {
            padding: 0;

            &:first-child {
              padding-right: 1rem;
            }

            .btn {
              width: auto;
            }
          }
        }

        .btn-outline {
          border: 0;
          border-bottom: 1px solid $blue-primary;
          border-radius: 0;
          padding: 0;
        }
      }
    }
  }
}
</style>
